import { Dictionary } from '../math/Dictionary.js';
import { Rect } from '../math/Shapes.js';
import { isUndefined } from '../utils/functions.js';

/**
 * Captures the state of a diagram; node positions, link points and so on.
 *
 * @type {*}
 */
class LayoutState {
    constructor(diagram, graphOrNodes) {
        if (isUndefined(diagram)) {
            throw new Error('No diagram given');
        }
        this.diagram = diagram;
        this.nodeMap = new Dictionary();
        this.linkMap = new Dictionary();
        this.capture(graphOrNodes ? graphOrNodes : diagram);
    }
    /**
     * Will capture either
     * - the state of the shapes and the intermediate points of the connections in the diagram
     * - the bounds of the nodes contained in the Graph together with the intermediate points of the links in the Graph
     * - the bounds of the nodes in the Array<Node>
     * - the links points and node bounds in the literal object
     *
     * @param diagramOrGraphOrNodes
     */
    capture(diagramOrGraphOrNodes) {
        let node, nodes, shape, i, conn, link, links;
        if (diagramOrGraphOrNodes && diagramOrGraphOrNodes.type === 'Graph') {
            for (i = 0; i < diagramOrGraphOrNodes.nodes.length; i++) {
                node = diagramOrGraphOrNodes.nodes[i];
                shape = node.associatedShape;
                // shape.bounds(new Rect(node.x, node.y, node.width, node.height));
                this.nodeMap.set(shape.visual.id, new Rect(node.x, node.y, node.width, node.height));
            }
            for (i = 0; i < diagramOrGraphOrNodes.links.length; i++) {
                link = diagramOrGraphOrNodes.links[i];
                conn = link.associatedConnection;
                this.linkMap.set(conn.visual.id, link.points());
            }
        }
        else if (diagramOrGraphOrNodes instanceof Array) {
            nodes = diagramOrGraphOrNodes;
            for (i = 0; i < nodes.length; i++) {
                node = nodes[i];
                shape = node.associatedShape;
                if (shape) {
                    this.nodeMap.set(shape.visual.id, new Rect(node.x, node.y, node.width, node.height));
                }
            }
        }
        else if (Object.prototype.hasOwnProperty.call(diagramOrGraphOrNodes, 'links') && Object.prototype.hasOwnProperty.call(diagramOrGraphOrNodes, 'nodes')) {
            nodes = diagramOrGraphOrNodes.nodes;
            links = diagramOrGraphOrNodes.links;
            for (i = 0; i < nodes.length; i++) {
                node = nodes[i];
                shape = node.associatedShape;
                if (shape) {
                    this.nodeMap.set(shape.visual.id, new Rect(node.x, node.y, node.width, node.height));
                }
            }
            for (i = 0; i < links.length; i++) {
                link = links[i];
                conn = link.associatedConnection;
                if (conn) {
                    this.linkMap.set(conn.visual.id, link.points);
                }
            }
        }
        else { // capture the diagram
            const shapes = this.diagram.shapes;
            const connections = this.diagram.connections;
            for (i = 0; i < shapes.length; i++) {
                shape = shapes[i];
                this.nodeMap.set(shape.visual.id, shape.bounds());
            }
            for (i = 0; i < connections.length; i++) {
                conn = connections[i];
                this.linkMap.set(conn.visual.id, conn.points());
            }
        }
    }
}

export { LayoutState };
